<div class="app-completed-items-container"
     role="main"
     aria-label="Completed items"
     data-testid="completed-items">
  <schedule-detail-header [title]="headerTitle"
                          [backLabel]="'Lot'"
                          [subtitle]="headerSubtitle()"
                          [backCallback]="goBack.bind(this)"
                          [showCloud]="true">
    <ng-container header-right>
      <button type="button"
              class="lot-kebab-btn"
              aria-label="Item list options"
              data-testid="completed-items-btn-kebab"
              (click)="openItemsMenu()">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </ng-container>
  </schedule-detail-header>

  <app-header [selectedFiltersCount]="selectedFiltersCount()"
              [showSelectAll]="false"
              (onCollapseItemsToggle)="onCollapseItemsToggle($event)"
              (onShowFilter)="toggleFilter()">
    <!-- Applied Filters Pills -->
    <div class="applied-filters-pills"
         data-testid="applied-filters-pills"
         role="list"
         aria-label="Applied filters">
      @for (group of filterService.getSelectedFiltersAsArray(); track group[0]) {
        @for (filter of group[1]; track filter.id) {
          <div class="applied-filter-pill"
               [attr.data-testid]="'applied-filter-' + filter.type + '-' + filter.id"
               role="listitem">
            <span class="pill-text">{{ filter.label | titlecase }}</span>
            <button class="pill-remove-btn"
                    (click)="onRemoveFilterPill(filter.type, filter.id)"
                    [attr.aria-label]="'Remove ' + filter.label + ' filter'"
                    data-testid="remove-applied-filter">
              <i class="pi pi-times"
                 aria-hidden="true"></i>
            </button>
          </div>
        }
      }
    </div>
  </app-header>

  <div class="app-completed-items"
       role="region"
       aria-label="Completed issues list"
       data-testid="completed-issues-region">
    <div class="issues-list"
         data-testid="issues-list">
      @if (loading()) {
        <div class="skeleton-container"
             role="status"
             aria-live="polite"
             data-testid="skeleton-container">
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
        </div>
      } @else if (sortedIssues().length === 0) {
        <div class="no-issues"
             role="status"
             aria-live="polite"
             data-testid="no-issues">
          <p>No completed items found.</p>
        </div>
      } @else {
        <div class="issues-container"
             role="list"
             data-testid="issues-container"
             [attr.aria-label]="'Completed issues list with ' + sortedIssues().length + ' items'">
          @for (issue of sortedIssues(); track issue.id) {
            <app-completed-item [issue]="issue"
                                (stateChange)="updateIssueState(issue, $event)"
                                (reopen)="reopenIssue($event)"
                                [vendors]="vendors()"
                                role="listitem"
                                [attr.data-testid]="'completed-issue-' + issue.id"
                                [attr.aria-label]="'Completed issue ' + (issue.areaName ? issue.areaName + ': ' : '') + issue.text">
            </app-completed-item>
          }
        </div>
      }
    </div>
  </div>

  <!-- Filter Drawer -->
  <app-filter-panel [isOpen]="filterService.isOpen()"
                    [FilterCategories]="FilterCategories"
                    [selectedFiltersCount]="filterService.selectedCount()"
                    [mode]="filterService.mode()"
                    [currentFilterType]="filterService.currentType()"
                    [filterValues]="filterService.values()"
                    [selectedFiltersDisplay]="filterService.selectedFiltersDisplay()"
                    [shouldShowNoVendorsText]="shouldShowNoVendorsText()"
                    [noVendorsText]="'There are no completed items with assigned Trade Partners.'"
                    [isSelectButtonDisabled]="filterService.isSelectButtonDisabled()"
                    [isApplyButtonDisabled]="filterService.isApplyButtonDisabled()"
                    (isOpenChange)="onFilterDrawerClose()"
                    (leftButtonClick)="onFilterClearAll()"
                    (rightButtonClick)="onFilterApply()"
                    (closeIconClick)="onFilterDrawerClose()"
                    (FilterCategoryClick)="onFilterCategoryClick($event)"
                    (filterValueToggle)="onFilterValueToggle($event)"
                    (modeChange)="onFilterModeChange($event)"
                    (removeFilterPill)="onRemoveFilterPill($event.filterType, $event.filterId)"
                    data-testid="filter-panel">
  </app-filter-panel>

  <app-bottom-sheet [(isOpen)]="isItemsMenuOpen"
                    [contentTemplate]="itemsMenuTemplate"
                    [hasFooter]="false"
                    [isFullScreen]="false"
                    [preventOverlayClose]="false"
                    data-testid="completed-items-sheet-items-menu" />

  <ng-template #itemsMenuTemplate>
    <div class="lot-menu-sheet"
         data-testid="completed-items-container-items-menu">
      <p-button label="Open Items"
                severity="contrast"
                class="lot-menu-sheet-btn"
                data-testid="completed-items-btn-navigate-open"
                (onClick)="navigateToOpenItems()" />
    </div>
  </ng-template>
</div>